import React from "react";
import { X } from "lucide-react";
import { formatMsk } from "../../utils/timeUtils";

// Ж12/Ж22: список уведомлений — общий для колокольчика, страницы настроек и push-истории
export const InboxList = ({ items, onOpenTask, onDelete, testPrefix = "inbox", emptyText = "Уведомлений пока нет", renderBadge }) => {
  if (!items.length) {
    return <p className="text-sm px-4 py-6 text-center" style={{ color: "var(--rv-text-muted)" }} data-testid={`${testPrefix}-empty`}>{emptyText}</p>;
  }
  return (
    <ul className="divide-y" style={{ borderColor: "var(--rv-border)" }} data-testid={`${testPrefix}-list`}>
      {items.map((n) => (
        <li key={n.id} className="px-4 py-3" data-testid={`${testPrefix}-item-${n.id}`}
          style={{ background: n.read === false ? "rgba(13,148,136,0.06)" : "transparent" }}>
          <div className="flex items-start gap-2">
            {n.read === false && <span className="mt-1.5 w-2 h-2 rounded-full flex-shrink-0" style={{ background: "var(--rv-teal)" }} data-testid={`${testPrefix}-unread-dot-${n.id}`} />}
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium break-words" style={{ color: "var(--rv-text-primary)" }} data-testid={`${testPrefix}-title-${n.id}`}>{n.title}</p>
              {n.body && <p className="text-xs mt-0.5 break-words" style={{ color: "var(--rv-text-secondary)" }}>{n.body}</p>}
              <div className="flex flex-wrap items-center gap-3 mt-1">
                <span className="text-xs" style={{ color: "var(--rv-text-muted)" }} data-testid={`${testPrefix}-time-${n.id}`}>{formatMsk(n.created_at)}</span>
                {renderBadge && renderBadge(n)}
                {n.task_id && onOpenTask && (
                  <button type="button" onClick={() => onOpenTask(n.task_id)} className="text-xs font-medium underline underline-offset-2"
                    style={{ color: "var(--rv-teal)", background: "none", border: "none", cursor: "pointer", padding: 0 }}
                    data-testid={`${testPrefix}-task-link-${n.id}`}>Открыть задание</button>
                )}
              </div>
            </div>
            {onDelete && (
              <button type="button" onClick={() => onDelete(n)} aria-label="Удалить уведомление" title="Удалить"
                className="flex-shrink-0 p-1 rounded-md" data-testid={`${testPrefix}-delete-${n.id}`}
                style={{ background: "none", border: "none", cursor: "pointer", color: "var(--rv-text-muted)" }}>
                <X size={14} />
              </button>
            )}
          </div>
        </li>
      ))}
    </ul>
  );
};
